import React from "react";
import { Package } from "@phosphor-icons/react";
import { PageShell } from "@/components/layout/AppLayout";
import { GlassCard } from "@/components/glass/GlassCard";
import StarterPackPicker from "@/components/StarterPackPicker";
import { useNavigate } from "react-router-dom";

/**
 * Post-onboarding access to the same starter-pack picker surfaced in the
 * welcome wizard. Lets existing tenant admins re-import or add additional
 * packs without re-running onboarding.
 */
export default function StarterPacks() {
  const nav = useNavigate();
  return (
    <PageShell
      title="Starter Packs"
      subtitle="Industry-tuned boilerplates, presets, workflows + mappings in a single import"
    >
      <GlassCard className="p-6">
        <div className="flex items-start gap-3 mb-5 pb-5 border-b border-[var(--border)]">
          <div className="w-10 h-10 rounded-md flex items-center justify-center bg-[var(--surface-strong)] text-[var(--accent)]">
            <Package size={20} weight="duotone" />
          </div>
          <div className="flex-1">
            <h3 className="text-base font-medium" style={{ fontFamily: "var(--font-heading)" }}>Pick a pack or upload your own</h3>
            <p className="text-[11px] text-[var(--text-2)] mt-1 leading-relaxed max-w-2xl">
              Each starter pack bundles boilerplate contracts, document-style presets, approval workflows, and the
              doc-type → workflow → preset mappings — so a fresh tenant can go from empty to production-ready in under a minute.
              Imports are name-idempotent: existing items are skipped, so re-running is always safe.
            </p>
          </div>
        </div>
        <StarterPackPicker allowSkip={false} onImported={() => nav("/app/doc-types")} />
      </GlassCard>
    </PageShell>
  );
}
